module.exports = __webpack_public_path__ + "static/media/back-button.728188e9.svg";